__webpack_require__.p = "/itscakess/";